/**
 * Single Firebase web app instance for the Cognitory landing shell.
 * Auth only — no Firestore, Storage, Analytics, or Functions clients.
 */

import { initializeApp, getApps, getApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

export const COGNITORY_LANDING_FIREBASE_PROJECT_ID =
  "smallgistics-cd63d" as const;

const firebaseConfig = {
  apiKey: "AIzaSyBmLNOykJH7eAaSxQZsD5P7IlQhUQtBm5k",
  authDomain: "smallgistics-cd63d.firebaseapp.com",
  projectId: COGNITORY_LANDING_FIREBASE_PROJECT_ID,
  storageBucket: "smallgistics-cd63d.firebasestorage.app",
  messagingSenderId: "641898304430",
  appId: "1:641898304430:web:9a7aecf59ea12dc0822e3f",
  measurementId: "G-WR83XXQHC0",
} as const;

export function getCognitoryFirebaseApp(): FirebaseApp {
  return getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
}

export function getCognitoryAuth(): Auth {
  return getAuth(getCognitoryFirebaseApp());
}
